RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.JobListItem = views.ContentListItem.extend({
        template: '#contentJobListItemTemplate'
    });

});
